<template>
  <div>
    <generic-table
      ref="datatable"
      :title="$t('credit analysis requests')"
      :columns="columns"
      :column_search="true"
      resource_url="/credit-analysis/request/datatables"
    >
      <template v-slot:buttons>
        <button class="button is-secondary is-rounded" @click="create">
          <span class="icon"><i class="fa fa-plus"></i></span>
          <span>{{ $t("new request") }}</span>
        </button>
        <!-- <button class="button is-info is-rounded" @click="refresh">
          <span class="icon"><i class="fa fa-sync"></i></span>
          <span>{{ $t("refresh") }}</span>
        </button> -->
        <!-- <div class="field is-horizontal ml-3">
          <div class="field-body">
            <div class="field">
              <div class="control">
                <label class="checkbox">
                  <input
                    type="checkbox"
                    v-model="show_only_own"
                    @change="toggleFilter"
                  />
                  {{ $t("show only my requests") }}
                </label>
              </div>
            </div>
          </div>
        </div> -->
      </template>
    </generic-table>

    <!-- Create/Edit Modal -->
    <credit-analysis-request-modal ref="modal" @saved="onSaved" />

    <!-- Detail Modal -->
    <credit-analysis-request-detail-modal ref="detail_modal" />
  </div>
</template>

<script>
import GenericTable from "@/components/generic_table/GenericTable.vue";
import CreditAnalysisRequestModal from "./credit_analysis_request_modal/Index.vue";
import CreditAnalysisRequestDetailModal from "./credit_analysis_request_detail_modal/Index.vue";
import {
  generate_datatables_buttons,
  confirm_deletion_dialog,
  format_currency,
  del,
  success_message,
  error_message,
} from "@/utils";
import moment from "moment";

export default {
  name: "CreditAnalysisRequestsDatatable",
  components: {
    GenericTable,
    CreditAnalysisRequestModal,
    CreditAnalysisRequestDetailModal,
  },
  data() {
    let v = this;
    return {
      show_only_own: false,
      additional_params: {},
      columns: [
        {
          title: this.$t("customer"),
          searchable: false,
          // width: "20%",
          data: (row) => {
            return `<div class="title is-5">${row.customer_name || ""}</div>
                    <div class="subtitle is-6 mb-1">
                      <span class="icon">
                        <i class="fa fa-id-card"></i>
                      </span>
                      <span>
                        <strong>${v.$t("dpi")}: </strong> ${row.dpi || ""}
                      </span>
                    </div>
                    <div class="subtitle is-6">
                      <span class="icon">
                        <i class="fa fa-tags"></i></span>
                      <span>
                        <strong>${v.$t("segment")}: </strong> ${v.$t(
              row.settings?.segment || "unset"
            )}
                      </span>
                    </div>`;
          },
        },
        {
          title: this.$t("other info"),
          searchable: false,
          // width: "15%",
          data: (row) => {
            let call_id = "";
            if (row.settings && row.settings.call_id) {
              call_id = `<div class="subtitle is-6 mb-0"><span class="icon"><i class="fa fa-phone"></i></span><span>
                <strong>${v.$t("call id")}: </strong> ${row.settings.call_id}
              </span></div>`;
            }

            let income = "";
            if (row.settings && row.settings.income) {
              income = `<div class="subtitle is-6"><span class="icon"><i class="fa fa-money"></i></span><span>
                <strong>${v.$t("income")}: </strong> ${format_currency(
                row.settings.income
              )}
              </span></div>`;
            }
            return `<div class="subtitle is-6 mb-0"><span class="icon"><i class="fa fa-file-text"></i></span><span>
              <strong>${v.$t("pagare")}: </strong> ${row.pagare_number || ""}
            </span></div>
            <div class="subtitle is-6 mb-0"><span class="icon"><i class="fa fa-id-card"></i></span><span>
              <strong>${v.$t("nit")}: </strong> ${row.nit || ""}
            </span></div>${call_id}${income}`;
          },
        },
        // {
        //   title: this.$t("customer name"),
        //   name: "customer_name",
        //   searchable: false,
        //   // width: "25%",
        //   data: (row) => row.customer_name || "",
        // },
        // {
        //   title: this.$t("nit"),
        //   name: "nit",
        //   searchable: false,
        //   // width: "12%",
        //   data: (row) => row.nit || "",
        // },
        // {
        //   title: this.$t("dpi"),
        //   name: "dpi",
        //   searchable: false,
        //   // width: "12%",
        //   data: (row) => row.dpi || "",
        // },
        // {
        //   title: this.$t("pagare number"),
        //   name: "pagare_number",
        //   searchable: false,
        //   // width: "15%",
        //   data: (row) => row.pagare_number || "",
        // },
        {
          title: this.$t("status"),
          name: "status",
          searchable: false,
          // width: "12%",
          data: (row) => {
            const statusClass = this.getStatusClass(row.status);

            // return `<span class="tag ${statusClass}">${this.$t(
            //   row.status || "draft"
            // )}</span>`;
            let evaluation_div = "";
            let comments_div = "";
            if (row.evaluation) {
              const resultClass = this.getResultClass(
                row.evaluation.final_result
              );
              evaluation_div = `<div class="control">
                <div class="tags has-addons are-medium">
                  <span class="tag is-dark">${v.$t("evaluation")}</span>
                  <span class="tag ${resultClass}">${v.$t(
                row.evaluation.final_result || "unset"
              )}</span>
                </div>
              </div>`;

              comments_div = row.evaluation.comments
                ? `<div class="content is-small mt-1 mb-0">
                    <strong>${v.$t("comments")}:</strong>
                    <p>${row.evaluation.comments}</p>
                  </div>`
                : "";
            }

            let deny_reason = "";
            if (row.deny_reason) {
              deny_reason = `<div class="control">
                <div class="tags has-addons">
                  <span class="tag is-dark">${v.$t("deny reason")}</span>
                  <span class="tag is-danger">${row.deny_reason.name}</span>
                </div>
              </div>`;
            }
            return `<div class="field is-grouped is-grouped-multiline">                      
                      <div class="control">
                        <div class="tags has-addons">
                          <span class="tag is-dark">${v.$t("status")}</span>
                          <span class="tag ${statusClass}">${v.$t(
              row.status || "unset"
            )}</span>
                        </div>
                      </div>
                      ${evaluation_div}
                      ${deny_reason}                      
                    </div>
                    ${comments_div}`;
            // const statusClass = this.getStatusClass(row.status);
            // return `<span class="tag ${statusClass}">${this.$t(
            //   row.status || "pending"
            // )}</span>`;
          },
        },
        {
          title: this.$t("request date"),
          name: "create_date",
          searchable: false,
          // width: "12%",
          data: (row) => {
            return `<div class="title is-6">${row.create_user?.username}</div>
            <div class="subtitle is-6">${moment(row.create_date).format(
              "DD/MM/YYYY HH:mm"
            )}</div>`;
          },
        },
        {
          title: this.$t("actions"),
          searchable: false,
          // width: "12%",
          data: (row) => {
            let v = this;
            let btns = [
              // {
              //   args: { uuid: row.uuid },
              //   tooltip: v.$t("view"),
              //   icon: "fa fa-eye",
              //   icon_class: "is-small has-text-info",
              //   click: (e) => {
              //     v.$refs.detail_modal.open(row.uuid);
              //   },
              // },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("delete"),
                icon: "fa fa-trash",
                icon_class: "is-small has-text-danger",
                click: (e) => {
                  let uuid = e.detail.uuid;
                  confirm_deletion_dialog(
                    v.$t("are you sure to delete credit analysis request?"),
                    v,
                    () => {
                      del("/credit-analysis/request", { uuid: uuid })
                        .then(() => {
                          v.refresh();
                        })
                        .catch((error) => {
                          error_message(error);
                        });
                    }
                  );
                },
              },
              //   {
              //     args: { uuid: row.uuid },
              //     tooltip: v.$t("edit"),
              //     icon: "fa fa-edit",
              //     icon_class: "is-small has-text-warning",
              //     click: (e) => {
              //       v.$refs.modal.open(row.uuid);
              //     },
              //   },
            ];

            return generate_datatables_buttons(btns);
          },
          // generate_datatables_buttons(
          //   //   row,
          //   //   this.edit,
          //   //   this.delete,
          //   //   this.view,
          //   [
          //     {
          //       title: this.$t("create evaluation"),
          //       icon: "fa fa-clipboard-check",
          //       class: "is-success",
          //       action: this.createEvaluation,
          //       condition:
          //         row.status === "pending" || row.status === "in_progress",
          //     },
          //   ]
          // ),
        },
      ],
    };
  },
  methods: {
    create() {
      this.$refs.modal.open();
    },
    edit(row) {
      this.$refs.modal.open(row.uuid);
    },
    view(row) {
      this.$refs.detail_modal.open(row.uuid);
    },
    delete(row) {
      confirm_deletion_dialog(() => {
        del("/credit-analysis/request", { uuid: row.uuid })
          .then(() => {
            success_message(this.$t("request deleted successfully"));
            this.refresh();
          })
          .catch((error) => {
            error_message(error);
          });
      });
    },
    createEvaluation(row) {
      // Redirigir a la página de evaluaciones con el UUID de la solicitud
      this.$router.push({
        path: "/credit-analysis/evaluations",
        query: { request_uuid: row.uuid },
      });
    },
    refresh() {
      this.$refs.datatable.refresh();
    },
    onSaved() {
      this.refresh();
    },
    toggleFilter() {
      //   if (this.show_only_own) {
      //     this.additional_params = { filter_own: "true" };
      //   } else {
      //     this.additional_params = {};
      //   }
      this.$nextTick(() => {
        setTimeout(() => {
          this.refresh();
        }, 500);
      });
    },
    getStatusClass(status) {
      const classes = {
        pending: "is-warning",
        in_progress: "is-info",
        completed: "is-success",
        denied: "is-danger",
      };
      return classes[status] || "is-light";
    },
    getResultClass(result) {
      if (result == "unevaluated") return "is-warning";
      else if (result == "rejected") return "is-danger";
      else if (result == "approved") return "is-success";
      else return "";
    },
  },
  mounted() {
    this.refresh();
  },
};
</script>

<style scoped>
.field.is-horizontal {
  align-items: center;
}

.checkbox {
  white-space: nowrap;
}
</style>
